import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-cognito',
    templateUrl: './cognito.component.html',
    styleUrls: ['./cognito.component.scss'],
    imports: [RouterOutlet, RouterModule]
})
export class CognitoComponent implements OnInit{
  fillerNav = Array(5).fill(0).map((_, i) => `Nav Item ${i + 1}`);
  fillerContent = Array(2).fill(0).map(() =>
      `Open side nav, and click on any navigation to close the opened side nav.`);
  constructor() {   
  }

  ngOnInit() {
  }

}
